export type SchedulerMeetingsDrilldownRouteType =
  | 'meetings-booked'
  | 'meetings-conducted'
  | 'meetings-cancelled';

export const SCHEDULER_STAT_CARD_TYPE = {
  MEETINGS_BOOKED: 'Meetings Booked',
  MEETINGS_CONDUCTED: 'Meetings Conducted',
  MEETINGS_CANCELLED: 'Meetings Cancelled',
} as const;

export const SCHEDULER_AMPLITUDE_EVENTS = {
  DASHBOARD: {
    ASSIGN_MEETING_HOST_SELECTED: 'Assign Meeting Host Selected',
    ASSIGN_MEETINGS_PANEL_OPENED: 'Assign Meetings Panel Opened',
    DASHBOARD_PAGE_VISITED: 'Dashboard Page Visited',
    MEMBER_PROFILE_VIEWED: 'Member Profile Viewed',
    MEETING_ASSIGNMENT_CONFIRMED: 'Meeting Assignment Confirmed',
    MEETING_CANCELLATION_CONFIRMED: 'Meeting Cancellation Confirmed',
    MEETING_RESCHEDULE_REQUESTED: 'Meeting Reschedule Requested',
    MEETINGS_TABLE_EXPORT_CLICKED: 'Meetings Table Export Clicked',
    RESCHEDULE_CANCEL_OPTION_SELECTED: 'Reschedule Cancel Option Selected',
    STAT_CARD_CLICKED: 'Stat Card Clicked',
    TEAM_MEMBER_ROW_CLICKED: 'Team Member Row Clicked',
    UPDATE_SCHEDULE_DROPDOWN_OPENED: 'Update Schedule Dropdown Opened',
  },
  DIRECT_SCHEDULING: {
    DIRECT_MEETING_SCHEDULED: 'Direct Meeting Scheduled',
    SCHEDULE_NOW_CLICKED: 'Schedule Now Clicked',
    SCHEDULE_NOW_INTERVIEWER_ADDED: 'Schedule Now Interviewer Added',
    SCHEDULE_NOW_TIME_SLOT_SELECTED: 'Schedule Now Time Slot Selected',
  },
  EVENTS: {
    CANCEL_EVENT_INITIATED: 'Cancel Event Initiated',
    EVENT_CANCELLED: 'Event Cancelled',
    EVENT_DETAIL_VIEWED: 'Event Detail Viewed',
    EVENTS_EMPTY_STATE_VIEWED: 'Events Empty State Viewed',
    EVENTS_PAGE_VISITED: 'Events Page Visited',
    REQUEST_RESCHEDULE_INITIATED: 'Request Reschedule Initiated',
    RESCHEDULE_REQUESTED: 'Reschedule Requested',
  },
  SETTINGS: {
    ACCOUNT_DISCONNECT_CONFIRMED: 'Account Disconnect Confirmed',
    CALENDAR_CONNECTED: 'Calendar Connected',
    CONNECT_TO_DIFFERENT_ACCOUNT_CLICKED:
      'Connect to Different Account Clicked',
    DISCONNECT_ACCOUNT_CLICKED: 'Disconnect Account Clicked',
    MEETING_CADENCE_UPDATED: 'Meeting Cadence Updated',
    WORKING_HOURS_SAVED: 'Working Hours Saved',
  },
  TEMPLATE: {
    COPY_LINK_CLICKED: 'Copy Link Clicked',
    TEAM_TEMPLATES_PAGE_VISITED: 'Team Templates Page Visited',
    TEMPLATE_CREATED: 'Template Created',
    TEMPLATE_CREATION_CANCELLED: 'Template Creation Cancelled',
    TEMPLATE_DELETED: 'Template Deleted',
    TEMPLATE_UPDATED: 'Template Updated',
    TEMPLATES_PAGE_VISITED: 'Templates Page Visited',
  },
} as const;

export const SCHEDULER_TEAM_PERFORMANCE_ANALYTICS_PAGE_NAME =
  'Team Performance Analytics';

export const SCHEDULER_MEMBER_MEETINGS_TABLE_CONTEXT = 'Member Meetings';

/** `initiated_from` for single-event panel reschedule/cancel flows. */
export const SCHEDULER_SINGLE_EVENT_DETAIL_INITIATED_FROM =
  'single_event_detail' as const;
